import { ChangeDetectionStrategy, Component, Optional, input, model } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { InputTextComponent } from '@pedix-workspace/angular-ui-form-reactive';
import { ControlContainer, FormsModule, NgForm, ValidatorFn } from '@angular/forms';
import { isPlausiblePhoneNumber } from '@pedix-workspace/utils';

@Component({
    selector: 'pxw-end-order-customer-fields',
    templateUrl: './end-order-customer-fields.component.html',
    styleUrls: ['./end-order-customer-fields.component.scss'],
    providers: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslocoDirective, InputTextComponent, FormsModule],
    viewProviders: [
        {
            provide: ControlContainer,
            deps: [[Optional, NgForm]],
            useFactory: (ngForm: NgForm) => ngForm,
        },
    ]
})
export class EndOrderCustomerFieldsComponent {
  readonly isFormSubmitted = input<boolean>(false);
  readonly personalInformationFieldsRequired = input<boolean>(false);

  readonly name = model.required<string | null | undefined>();
  readonly phone = model.required<string | null | undefined>();

  protected charactersAndSpacePattern = /^[A-Za-zÁÉÍÓÚÜáéíóúüñÑ0-9 ]+$/;

  protected readonly phoneValidator: ValidatorFn = control =>
    control.value && !isPlausiblePhoneNumber(control.value) ? { invalidPhone: true } : null;
}
